import { TFuelLevyType, TRateCardFuelLevies, TRateCardFuelLevy } from '@types';

export const getSelectedFuelLevy = (
	fuelLevies: TRateCardFuelLevies | null | undefined,
	type: TFuelLevyType,
	fuelLevyId?: string | null,
): TRateCardFuelLevy | null | undefined => {
	if (type !== 'customer') return fuelLevies?.[type];

	const levies = fuelLevies?.customer_levies ?? [];
	return levies.find((levy) => levy.id === fuelLevyId) ?? levies[0];
}
